import Close from '@mui/icons-material/Close';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grow from '@mui/material/Grow';
import { alpha, styled } from '@mui/material/styles';
import { VerticalScroll } from '@qpr/components';
import React, { ReactNode } from 'react';

const PREFIX = 'CardExpansion';

const classes = {
  expandedContainer: `${PREFIX}-expandedContainer`,
  closeIcon: `${PREFIX}-closeIcon`
};

const StyledGrow = styled(Grow)(({ theme }) => ({
  [`& .${classes.expandedContainer}`]: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: 1,
    top: 0,
    background: alpha(theme.palette.background.paper, 0.6),
    color: alpha(theme.palette.grey[900], 0.9)
  },

  [`& .${classes.closeIcon}`]: {
    verticalAlign: 'middle',
    cursor: 'pointer',
    float: 'right'
  }
}));

export interface ExpansionProps {
  children: ReactNode;
  show: boolean;
  title: string;
  onClose: () => void;
}

const CardExpansion = ({ title, children, show, onClose }: ExpansionProps) => {
  return show ? (
    <StyledGrow in timeout={{ enter: 350, exit: 250 }}>
      <Card className={classes.expandedContainer} data-testid="expansible-properties">
        <CardHeader
          title={
            <>
              <Close data-testid="close-icon" className={classes.closeIcon} onClick={onClose} />
              {title}
            </>
          }
          titleTypographyProps={{ align: 'left', variant: 'h6' }}
        />
        <VerticalScroll>
          <CardContent>{children}</CardContent>
        </VerticalScroll>
      </Card>
    </StyledGrow>
  ) : null;
};

export default CardExpansion;
